module.exports = __webpack_public_path__ + "static/img/114.6c723f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/114.jpg
// module id = 2ATz
// module chunks = 2